import CartIcon from '@components/icons/cart-icon';
import { useCart } from '@contexts/cart/cart.context';
import { useUI } from '@contexts/ui.context';
import { getCurrentLocationAndLanguage } from '@utils/location';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
export default function CartButton() {
  const {
    openCart,
    isAuthorized,
    setModalView,
    openModal
  } = useUI();
  const {
    location
  } = getCurrentLocationAndLanguage();
  const {
    totalItems
  } = useCart();
  const [displayedTotalItems, setDisplayedTotalItems] = useState(totalItems);
  const router = useRouter();
  useEffect(() => {
    setDisplayedTotalItems(totalItems);
  }, [totalItems]);
  const hiddenPaths = ['/checkout', '/pay', '/payment', '/order/[orderid]/delivery-payment'];
  if (hiddenPaths.some(hiddenPath => router.pathname.startsWith(hiddenPath))) {
    return null;
  }
  function handleCartOpen() {
    if (location !== 'kg' && !isAuthorized) {
      setModalView('LOGIN_VIEW');
      openModal();
      return;
    }
    openCart();
  }
  return <button className="relative flex items-center justify-center flex-shrink-0 h-auto transform focus:outline-none" onClick={handleCartOpen} aria-label="cart-button" data-sentry-component="CartButton" data-sentry-source-file="cart-button.tsx">
      <CartIcon data-sentry-element="CartIcon" data-sentry-source-file="cart-button.tsx" />
      <span className="cart-counter-badge flex items-center justify-center bg-heading text-white absolute -top-2.5 xl:-top-3 rounded-full ltr:-right-2.5 ltr:xl:-right-3 rtl:-left-2.5 rtl:xl:-left-3 font-bold">
        {displayedTotalItems}
      </span>
    </button>;
}